<video [src]="src" loop #video (mouseover)="handleMouseOver()" (mouseout)="handleMouseOut()"></video>